import { ReactNode } from 'react'
import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
    width: '100%'
  }
}))

type Props = {
  children: ReactNode
}

function Container({ children }: Props): JSX.Element {
  const classes = useStyles()
  return <div className={classes.root}>{children}</div>
}

export default Container
